export default "__VITE_ASSET__aLISaAY6NSiJFT$6GdtrfA__ 480w, __VITE_ASSET__Msg57USEadASvSStYSdmzA__ 768w, __VITE_ASSET__epdbhdyBUyD3hvxx0_dcTg__ 1200w";